/**
 * Banker Portal Layout — shared shell for inbox + case detail.
 * Includes header with banker name + bank code + logout.
 */
import React from 'react';
import { useNavigate, Link, Outlet } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Landmark, LogOut } from 'lucide-react';

export default function BankerLayout() {
  const navigate = useNavigate();
  const raw = localStorage.getItem('banker_profile');
  const banker = raw ? JSON.parse(raw) : null;

  React.useEffect(() => {
    if (!localStorage.getItem('banker_token')) navigate('/banker/login');
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem('banker_token');
    localStorage.removeItem('banker_profile');
    navigate('/banker/login');
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="banker-layout">
      <header className="bg-slate-900 text-white px-4 py-3 flex items-center gap-3">
        <Link to="/banker/inbox" className="flex items-center gap-2 font-semibold">
          <Landmark className="w-5 h-5" /> Banker Portal
        </Link>
        <div className="ml-auto flex items-center gap-3 text-sm">
          {banker && (
            <span data-testid="banker-name">
              {banker.name} · <span className="font-mono text-indigo-300">{banker.bank_code}</span>
            </span>
          )}
          <Button size="sm" variant="ghost" onClick={logout} className="text-white hover:bg-slate-800" data-testid="banker-logout">
            <LogOut className="w-4 h-4 mr-1" /> Logout
          </Button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto p-4">
        <Outlet />
      </main>
    </div>
  );
}
